import { appActions } from '@app';
import { createSonarSelector } from '@lib/selectors';
import { useAction } from './useAction';
import { useCallback } from 'react';
import { useSonarSelector } from './useSonarSelector';

const selector = createSonarSelector((state) => Boolean(state.application.sidebar.read.data?.closed));

export interface UseApplicationSidebarResult {
	close: () => void;
	isClosed: boolean;
	open: () => void;
	toggle: () => void;
}

export function useApplicationSidebar(): UseApplicationSidebarResult {
	const isClosed = useSonarSelector(selector);
	const update = useAction(appActions.updateApplicationSidebar);

	const close = useCallback(() => {
		update({
			closed: true
		});
	}, [ update ]);

	const open = useCallback(() => {
		update({
			closed: false
		});
	}, [ update ]);

	const toggle = useCallback(() => {
		update({
			closed: !isClosed
		});
	}, [ isClosed, update ]);

	return {
		close,
		isClosed,
		open,
		toggle
	};
}
